import { Button } from '@/shared/components';

interface Props {
  selectedCount: number;
  total: number;
  onClear: () => void;
  onCreate: () => void;
  onRelease: () => void;
}

/**
 * Dunkle Leiste unten (Board „Belegung · Stellplätze“), nur mit Auswahl: erst anhaken, dann
 * handeln. Sie öffnet die bestehenden Dialoge – anlegen (Sperre oder Buchung) und aufheben. Am Handy
 * zwei Zeilen: Anzahl mit „Auswahl leeren“, darunter beide Aktionen nebeneinander.
 */
export function ParkingSelectionBar({ selectedCount, total, ...props }: Props) {
  if (selectedCount === 0) return null;
  return (
    <div
      role="region"
      aria-label="Auswahl der Stellplätze"
      className="bg-ink sticky bottom-0 z-30 grid grid-cols-2 items-center gap-2 px-3 py-3 text-white md:flex md:flex-wrap md:gap-2.5 md:px-[18px] md:py-3.5"
    >
      <span className="col-span-2 flex items-center gap-2 md:contents">
        <span className="grow text-sm font-bold">
          {selectedCount} von {total}
          <span className="hidden md:inline"> Stellplätzen</span> ausgewählt
        </span>
        <button
          type="button"
          onClick={props.onClear}
          className="text-on-forest-soft min-h-11 whitespace-nowrap px-2 text-[13px] font-bold md:order-last md:px-3.5"
        >
          Auswahl leeren
        </button>
      </span>
      <Button
        variant="secondary"
        className="text-ink min-h-11 min-w-0 bg-white"
        onClick={props.onCreate}
      >
        <span className="md:hidden">Belegung anlegen</span>
        <span className="hidden md:inline">Belegung anlegen · Sperre oder Buchung</span>
      </Button>
      {/* Der Weg zurück steht neben dem Weg hin: eine Belegung, die sich nur anlegen ließe, hielte
          einen Platz bei jedem Fehlgriff bis zum Ende ihres Zeitraums unverkäuflich. */}
      <Button
        variant="ghost-dark"
        className="min-h-11 min-w-0 border-[1.5px] border-white/40"
        onClick={props.onRelease}
      >
        <span className="md:hidden">Aufheben</span>
        <span className="hidden md:inline">Belegung aufheben</span>
      </Button>
    </div>
  );
}
